const en = {
    title: 'Remote viewing',
    description: 'Keep using this player and queue. The paired tablet follows your videos.',
    statusIdle: 'Not connected',
    statusPreparing: 'Preparing link…',
    statusWaiting: 'Waiting for viewing screen',
    statusConnecting: 'Connecting…',
    statusConnected: 'Screen connected',
    connect: 'Connect viewing screen',
    newLink: 'Create new link',
    disconnect: 'Disconnect',
    qrLabel: 'QR code to connect the viewing screen',
    qrCaption: 'Scan with the tablet camera',
    qrInstructions: 'Scan the QR code with the tablet camera to open the viewing screen. Use the same Wi-Fi for a direct connection; a server connection is available automatically if needed.',
    qrExpiry: 'This code expires in 10 minutes and pairs one screen. Tap Start session on the tablet after connecting.',
    linkLabel: 'Or open this link on the tablet:',
    copyLink: 'Copy link',
    copySuccess: 'Link copied',
    copyManual: 'Select the link above and copy it to the tablet.',
    connectionDirect: 'Connection: direct',
    connectionServer: 'Connection: via server',
    viewerReady: 'Viewing screen ready.',
    viewerPlaying: 'Video playing on the viewing screen.',
    viewerPaused: 'Viewing screen paused.',
    viewerWaiting: 'Waiting for the viewing screen to start.',
    viewerBlocked: 'Tap Start session on the viewing screen to allow playback.',
    viewerVideoError: 'The viewing screen could not load this video.',
    connectingServer: 'Connecting through the server…',
    controllerDisconnected: 'Viewing screen disconnected. Create a new link to reconnect.',
    linkExpired: 'Pairing link expired. Create a new link on the controller to try again.',
    viewerTitle: 'Teddy viewing screen',
    viewerScreenLabel: 'Teddy viewing screen',
    viewerConnecting: 'Connecting to the therapist’s player…',
    viewerConnected: 'Connected. The therapist controls the videos.',
    viewerStart: 'Start session',
    viewerHint: 'Keep this screen open. Double-tap the video to enter fullscreen again.',
    viewerDisconnected: 'The controller disconnected. Ask the therapist to create a new pairing link.',
    viewerLost: 'Connection lost. Ask the therapist to create a new pairing link.',
    viewerMissingLink: 'Open a pairing link from the therapist’s Remote viewing panel.',
    viewerLinkNotReady: 'This link is not ready. Ask the therapist for a new link.',
    viewerTimeout: 'Could not reach the therapist’s player. Keep it open, then ask for a new pairing link.',
    errorConnection: 'Could not connect the viewing screen. Please try again.',
    errorSameWebsite: 'Pair both devices using the same website.',
    errorMessageTooLarge: 'The connection message is too large. Create a new pairing link.',
    errorInvalidOffer: 'Could not prepare the connection. Create a new pairing link.',
    errorBusy: 'Pairing is busy. Please try again shortly.',
    errorCredentials: 'This pairing link is invalid. Ask the therapist for a new link.',
    errorLinkUsed: 'This link has already been used. Create a new link.',
    errorOperation: 'Could not complete pairing. Create a new link.',
    errorAnswer: 'Could not complete the connection. Create a new pairing link.',
    errorSessionEnded: 'This session has ended. Ask the therapist for a new pairing link.',
    errorPlayback: 'Could not synchronize playback. Create a new pairing link.',
    errorServerTimeout: 'The server connection timed out. Please try again.',
    errorUnsupportedBrowser: 'This browser does not support remote viewing.',
    errorNoCandidate: 'No direct connection address was found.',
};

export default en;
